import DatepickerFunctions from "./DatepickerHelper";
import Settings from "./Settings";
import { formatJson, isEmptyObject } from "./Validation";

export const transformObjectTemplates = (data, moduleList) => {
    return data?.map((item) => {
        return {
            ...item,
            module_id: moduleList?.find((type) => type.value == item.module_id)?.label
        }
    })
};

export const transformObjectWorkflowActions = (data) => {
    return data?.map((item) => {
        return {
            label: item.label,
            url: item.url,
            payload: !isEmptyObject(item?.payload) ? formatJson(item?.payload) : '',
            method: item.method
        }
    })
};

export const transformObjectEmailNotifications = (data, eventsList, emailTemplates, teamsList) => {
    return data?.map((item) => {
        return {
            ...item,
            event_id: eventsList?.find((type) => type.value == item.event_id)?.label,
            emailtemplate_id: emailTemplates?.find((type) => type.value == item.emailtemplate_id)?.label,
            cc_members: teamsList?.find((type) => type.value == item.cc_members)?.label,
            trigger_push_notification: item.trigger_push_notification ? "Yes" : "No",
            trigger_email: item.trigger_email ? "Yes" : "No"
        }
    })
};

export const transformObjectPendingTasks = (data, sources) => {
    return data?.map((item) => {
        return {
            ...item,
            module_id: sources?.find((type) => type.value == item.module_id)?.label,
            due_date: DatepickerFunctions.convertDateFromDataBase(item.due_date),
            initiated_date: DatepickerFunctions.convertDateFromDataBase(item.initiated_date),
        }
    })
};

export const transformObjectWorkflows = (data, templateData) => {
    return data?.map((item) => {
        return {
            ...item,
            template_id: templateData?.find((type) => type.value == item.template_id)?.label
        }
    })
};

